<div class="users">
  <app-page-header
    breadcrumb="Administration"
    [doubleArrows]="true"
    title="Users"
    [keepIconOnMobile]="true"></app-page-header>
  @if (isTableInitiating) {
    <app-action-buttons-skeleton></app-action-buttons-skeleton>
    <app-table-skeleton></app-table-skeleton>
  } @else {
    <div class="users__action-buttons">
      <app-user-filters [columns]="columnsToDisplay" (filterApplied)="onFilterChange($event)"></app-user-filters>
      <button class="users__action-buttons--new-user" mat-stroked-button (click)="createUser()">
        New user
        <mat-icon>person_add</mat-icon>
      </button>
      <app-excel-export [selectedUsers]="selectedUsers" [pageConfig]="pageConfig$ | async"></app-excel-export>
    </div>
    <div class="users__table-wrapper">
      <table mat-table [dataSource]="tableData.data" class="users__table" matSort (matSortChange)="onSort($event)">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="$event ? toggleAllRows() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnsToDisplayMap.get('name') }}</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ columnsToDisplayMap.get('email') }}</th>
          <td mat-cell *matCellDef="let element">{{ element.email }}</td>
        </ng-container>
        <ng-container matColumnDef="mainPartyName">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ columnsToDisplayMap.get('mainPartyName') }}</th>
          <td mat-cell *matCellDef="let element">{{ element.mainPartyName }}</td>
        </ng-container>
        <ng-container matColumnDef="latestLogin">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ columnsToDisplayMap.get('latestLogin') }}</th>
          <td mat-cell *matCellDef="let element">{{ element.latestLogin | date }}</td>
        </ng-container>
        <ng-container matColumnDef="userType">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ columnsToDisplayMap.get('userType') }}</th>
          <td mat-cell *matCellDef="let element">{{ element.userType }}</td>
        </ng-container>
        <ng-container matColumnDef="portalAccess">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ columnsToDisplayMap.get('portalAccess') }}</th>
          <td mat-cell *matCellDef="let element">{{ element.portalAccess ? 'Yes' : 'No' }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let element" class="users__table--actions-cell">
            <button
              matIconButton
              [ngStyle]="{ 'margin-left': '-10px' }"
              (click)="editUser(element)"
              matTooltip="Edit user">
              <mat-icon>edit</mat-icon>
            </button>
            <button matIconButton (click)="copyUser(element)" matTooltip="Copy user">
              <mat-icon>content_copy</mat-icon>
            </button>
            @if (isUserAdmin$ | async) {
              <div
                class="users__table--action-delete-wrapper"
                matTooltip="Internal Users are managed in the Active Directory and cannot be deleted in MySGL"
                [matTooltipDisabled]="element.userType !== 'Internal'">
                <button
                  matIconButton
                  [disabled]="element.userType === 'Internal'"
                  [attr.aria-disabled]="element.userType === 'Internal'"
                  (click)="deleteUser(element)"
                  matTooltip="Delete user">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="users__table--header-row"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr *matNoDataRow>
          <td [attr.colspan]="displayedColumns.length">No data found</td>
        </tr>
      </table>
    </div>
    <mat-paginator
      [disabled]="isLoading"
      [pageIndex]="(tableData.pageNumber || 1) - 1"
      [length]="tableData.totalCount"
      [pageSize]="tableData.pageSize"
      [pageSizeOptions]="[20, 50, 100]"
      (page)="onPaginationChange($event)"></mat-paginator>
  }
  @if (isLoading) {
    <div class="spinner">
      <mat-spinner diameter="60"></mat-spinner>
    </div>
  }
</div>
